module.exports = __webpack_public_path__ + "static/media/background-1-def-inner-webapp.fa8284c4.webp";